import React from "react";

const EmployeeCard = props => {
  const { list, fleetNo, fldDesc } = props;
  const bottomContent = (bottom, type) => {
    if (!bottom) return <label>No Record</label>;
    switch (type) {
      case undefined:
        return <label>{bottom}</label>;
      case "email":
        return (
          <label>
            {bottom && (
              <a
                href={`mailto:${bottom}?subject=Equipment%20(${fleetNo}-${fldDesc})`}
              >
                {bottom}
              </a>
            )}
          </label>
        );
      case "phone":
        return (
          <label>{bottom && <a href={`tel:+1 ${bottom}`}>{bottom}</a>}</label>
        );
      default:
        break;
    }
  };

  const cell = (top, bottom, dark = false, type) => (
    <div className={`cardComponent EC${top}`} key={`${top}-${bottom}`}>
      <label>{dark ? <strong>{top}</strong> : top}</label>
      {bottomContent(bottom, type)}
    </div>
  );
  return (
    <div className="employeeCard">
      {/* <div className="img"></div> */}
      {list.map((elem, index) => cell(elem.top, elem.bottom, true, elem.type))}
    </div>
  );
};

export default EmployeeCard;
